import axios from "axios";
const request: any = axios.create({
  baseURL: 'https://dflapi.iduoyu.net/prod-api',
  // baseURL: 'http://192.168.0.6:9093',
  timeout: 10000,
})

request.interceptors.response.use(
  ({ data }: any) => {
    return data
  },
  (error: any) => {
    // 对响应错误做点什么
    // return Promise.reject(error)
  }
)
export default request
